import React, { useMemo } from 'react';

import { DataListInput } from '@components/DataListInput';

import { FilterComponentProps } from './types';
import { useTableDataForFilterValues } from './useTableDataForFilterValues';

interface DataListFilter<TData> extends FilterComponentProps<TData> {
  filterData?: string[];
}

function mappingFn(val: unknown) {
  return val as string;
}

function DataListFilter<TData>({
  column,
  filterData,
  value,
  dataChangeTriggerFn,
  onChange,
  ...extraProps
}: DataListFilter<TData>) {
  const { values } = useTableDataForFilterValues<TData, string>({
    filterData,
    dataChangeTriggerFn,
    column,
    uniqueIdKey: '_primitive',
    mappingFn,
  });

  const sortedFacetedUniqueValues = useMemo(() => {
    return values.sort();
  }, [values]);

  const handleChange = (value: string) => {
    onChange?.(value, { column, filterData });
  };

  return (
    <DataListInput
      items={sortedFacetedUniqueValues}
      onChange={handleChange}
      placeholder="Search"
      provideValueOnChange
      {...extraProps}
      value={(value as string) ?? ''}
    />
  );
}

export { DataListFilter };
